import SharedSortableLists from "./SharedSortableLists";

// Base class for prepress tables that are sortable based on print provider
class PrepressSortTable extends SharedSortableLists {
  defaultSortKey() {
    return "all";
  }

  inHouseWilmingtonProvider() {
    return "In House - Wilmington";
  }

  inHouseDallasProvider() {
    return "In House - Dallas";
  }

  inHouseIrvingProvider() {
    return "In House - Irving";
  }

  reactTableExtra() {
    return { statuses: this.statuses };
  }

  sortData() {
    switch (this.sortKey) {
      case "in_house_wilmington":
        return this.showInHouse(this.inHouseWilmingtonProvider());
      case "in_house_dallas":
        return this.showInHouse(this.inHouseDallasProvider());
      case "in_house_irving":
        return this.showInHouse(this.inHouseIrvingProvider());
      case "outsourced":
        return this.showOutSourced();
      default:
        return this.data;
    }
  }
}

export default PrepressSortTable;
